import Menu from './js/Controller';

new Menu({
    tab: "menu__tab",
    tabsContainer: "menu__tabs",
    contentContainer: "menu__content",
});
